module.exports = __webpack_public_path__ + "static/media/cross.d8adf1c0.svg";